import * as React from 'react'
import { Button, Popover, useEffectWithPolling, WidgetWrapper } from 'uxp/components'
import { IUIPropertyDefinitionMap, IWidgetTemplateProps, registerCardTemplate } from '../../../common/common'
import { generateIconProp } from '../../../common/icon-selector/IconEditor'
import { SelectableItem, selectUIProps } from '../../../common/SelectableItem'
import { ContainerProperty, extractContainerProperties } from '../../../common/ui-props/ContainerProperty'
import { extractTextProperties, TextProperty } from "../../../common/ui-props/TextProperty";
import { DataSourceProperty } from "../../../common/ui-props/DataSourceProperty";

import './styles.scss'
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import { executeAndBind } from '../../../common/data-source-picker/datasource'
import { ITwoValueWidgetProps, TwoValueWidgetProperty } from './TwoValueWidgetProperty'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ThemeSelector } from '../../../common/theme-selector/theme-selector'
import { extractContextData, loadInitialData, replaceWithData } from '../../../../util'
import { IContextData, useInitialContextData } from '../../../../hooks/useContextData'
let DefaultChartProperties: ITwoValueWidgetProps = {
    refreshInterval: 60000,
    channel: '',
    firstValueField: '',
    secondValueField: '',
    firstColor: '#364E7F',
    secondColor: '#F8DE80',
    circleColor: 'black',
    circleIconColor: 'white',
    circleIcon: '',
    secondValueIsTotal: false,
    firstValueLabel: 'Occupied',
    secondValueLabel: 'Unoccupied',
    firstValueLabelColor: '#FFF',
    secondValueLabelColor: '#FFF',

};
const XPR: React.FunctionComponent<IWidgetTemplateProps> = props => {
    let uiProps = props?.uiProps || {};
    let [firstValue, setFirstValue] = React.useState(0);
    let [secondValue, setSecondValue] = React.useState(0);

    const [loading, setLoading] = React.useState(false)
    let [contextData, setContextData] = React.useState<IContextData>({})

    const { isLoading, initialContextData } = useInitialContextData(props, [uiProps?.source])

    const XPRProps: IUIPropertyDefinitionMap = {
        "headerContainer": ContainerProperty({
            background: {
                color: "#FFFFFF",
                image: {
                    image: "",
                    position: "",
                    size: "",
                },
            }
        }),
        'title': TextProperty({ text: '', color: '', size: '' }, 'Title'),
        'source': DataSourceProperty('Source', uiProps.source, uiProps.datasources, props.uxpContext, props.designer, 'dictionary'),
        'chartProperty': {
            'all': TwoValueWidgetProperty('all', 'Data', uiProps.chartProperty || DefaultChartProperties),
            'circle': TwoValueWidgetProperty('circle', 'Data', uiProps.chartProperty || DefaultChartProperties),
        }
    }

    let { styles: headerStyles } = extractContainerProperties(uiProps.headerContainer)
    let { text: title, styles: titleStyles } = extractTextProperties(uiProps.title, 'Widget Title')
    title = replaceWithData(title, contextData)
    let chartProps: ITwoValueWidgetProps = props.uiProps.chartProperty || DefaultChartProperties;

    let { refreshInterval, channel } = chartProps;

    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    useEffectWithPolling(props.uxpContext, channel || "chart/1", refreshInterval || 60000, async () => {
        if (props.designer && (props.designer.mode == 'preview' || props.designer.mode == 'thumbnail')) {
            setFirstValue(40);
            setSecondValue(60);
            return;
        }

        executeAndBind(props.uxpContext, uiProps.source, uiProps.datasources, {}, contextData)
            .then(res => {
                let f = Number(res[chartProps.firstValueField || 'count']);
                let s = Number(res[chartProps.secondValueField || 'count1']);
                if (chartProps.secondValueIsTotal) {
                    s = Math.max(0, s - f);
                }
                setFirstValue(f);
                setSecondValue(s);

            })
    }, [props.designer]);

    let firstWidth = firstValue / (firstValue + secondValue) || 0.5;
    if (firstWidth < 0.2) firstWidth = 0.2;
    let secondWidth = 1.0 - firstWidth;

    const firstValueLabel = replaceWithData(chartProps.firstValueLabel, contextData)
    const secondValueLabel = replaceWithData(chartProps.secondValueLabel, contextData)

    return <WidgetWrapper className='uxp-custom-two-value-chart-template'>
        <div className="two-value-chart-container">
            {/* <div className="header">
                <SelectableItem
                    designer={props.designer}
                    props={selectUIProps(uiProps, XPRProps, 'headerContainer', 'title')}
                    data={data}
                >
                    <div className="uxp-widget-title-bar uxp-drag-handler" style={headerStyles}>
                        <div className="title-section" style={titleStyles}>
                            <span className="title-icon"></span>
                            <span className="txt">{title}</span>
                        </div>
                        <div className="action-section">

                        </div>
                    </div>
                </SelectableItem>
            </div> */}


            {/* <div className="bg" style={chartContainerStyles}>
              
               
            </div> */}
            <SelectableItem
                style={{ position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }}
                designer={props.designer}
                props={selectUIProps(uiProps, XPRProps, 'headerContainer', 'title', 'source', 'chartProperty.all', 'chartContainer')}
                contextData={contextData}
            >
                <div className='content'>
                    <div className='first' style={{ width: `${firstWidth * 100}%`, backgroundColor: chartProps.firstColor }} >
                        <div className='lbl' style={{ color: chartProps.firstValueLabelColor }}>
                            <div className='v'>{Number(firstValue).toFixed(0)}</div>
                            <div className='u'>{firstValueLabel}</div>
                        </div>
                    </div>
                    <div className='second' style={{ width: `${secondWidth * 100}%`, backgroundColor: chartProps.secondColor }} >
                        <div className='lbl' style={{ color: chartProps.secondValueLabelColor }}>
                            <div className='v'>{Number(secondValue).toFixed(0)}</div>
                            <div className='u'>{secondValueLabel}</div>
                        </div>
                    </div>
                    <SelectableItem
                        showAtRuntime={true}
                        designer={props.designer}
                        props={selectUIProps(uiProps, XPRProps, 'chartProperty.circle')}
                        style={{ left: `${firstWidth * 100}%`, backgroundColor: chartProps.circleColor }}
                        className='circle'
                        contextData={contextData}
                    >

                        <FontAwesomeIcon style={{ width: '50%', height: '50%', left: '25%', top: '25%', position: 'absolute' }} color={chartProps.circleIconColor} icon={generateIconProp(chartProps.circleIcon)} />

                    </SelectableItem>
                </div>

                <div className='header-title'>
                    <SelectableItem
                        contextData={contextData}
                        designer={props.designer}
                        props={selectUIProps(uiProps, XPRProps, 'headerContainer')}
                    >
                        <div className='header-container' style={headerStyles}>
                            <SelectableItem
                                designer={props.designer}
                                props={selectUIProps(uiProps, XPRProps, 'title')}
                                contextData={contextData}
                            >
                                <div className='txt' style={titleStyles}>{title}</div>
                            </SelectableItem>
                        </div>
                    </SelectableItem>
                </div>

            </SelectableItem>

        </div>
    </WidgetWrapper>
}
interface IWidgetTheme {
    firstColor: string;
    secondColor: string;
    circleColor: string;
}
let Themes: IWidgetTheme[] = [
    {
        firstColor: '#2f4f83',
        circleColor: 'black',
        secondColor: '#F8DE80',
    },
    {
        firstColor: '#8AD4F9',
        circleColor: 'white',
        secondColor: 'black',
    },

    {
        firstColor: '#75CB99',
        circleColor: 'white',
        secondColor: 'black',
    },
    {
        firstColor: "#F7C644",
        secondColor: "#EE9653",
        circleColor: "black",
    },
    {
        firstColor: "#E76965",
        secondColor: "#75CB99",
        circleColor: "black",
    }
];
const TB: React.FunctionComponent<IWidgetTemplateProps> = props => {
    let [showingThemeSelector, setShowingThemeSelector] = React.useState(false);
    return <><div className='template-toolbar-content'>
        <Button
            icon={'fas eye'}
            title={'Select a theme'}
            onClick={() => {
                setShowingThemeSelector(!showingThemeSelector);
            }}
            className='nav-btn'
        />


    </div>
        {showingThemeSelector && <ThemeSelector
            onClose={() => {
                setShowingThemeSelector(false);
            }}
            onRender={(props) => {
                return <div className='uxp-theme-two-value-widget'>
                    <div style={{ backgroundColor: props.firstColor }} className='first-item' />
                    <div style={{ backgroundColor: props.secondColor }} className='second-item' />
                    <div style={{ backgroundColor: props.circleColor }} className='circle' />
                </div>;
            }}
            themes={Themes}
            onSelect={(_p) => {
                let newProps = Object.assign({}, props.uiProps);
                if (!newProps.chartProperty) newProps.chartProperty = DefaultChartProperties;
                newProps.chartProperty = Object.assign(newProps.chartProperty, _p);
                props.designer.setUIProps(newProps);
            }}
        />}
    </>;

};

registerCardTemplate({
    id: 'two-value-widget',
    name: 'Percentage Widget',
    description: 'This widget visualizes two complementary values that combine to make a total. Like occupancy.',
    template: XPR,
    toolbar: TB,
    icon: generateIconProp('tachometerAlt'),
    complexity: 'easy',
    preLoader: 'donut-chart'
});
